import React, {useState, useEffect, useContext} from 'react';
import Datepicker from 'react-datepicker';
import { parse } from 'date-fns';
import { enGB, fr, nl, de } from 'date-fns/locale';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { LanguageContext } from "../../containers/Language/LanguageProvider";
import './calendarrevenue.css';
import { RevenueCalendarContext } from '../context/RevenueCalendarProvider';

export default function WeeklyDatePicker(props) {
    const localeList = [enGB, fr, nl, de];
    const [highlightDatesByStatus, setHighlightDatesByStatus] = useState([]);  
    const languageContext = useContext(LanguageContext);
    const { setRawDateHandler } = useContext(RevenueCalendarContext);

    useEffect(()=> {
        const selectedLanguage = languageContext && languageContext.language;
        if(selectedLanguage) {
            const selectedLangId = parseInt(selectedLanguage.id);
            registerLocale(selectedLanguage.text, localeList[selectedLangId-1]);
            setDefaultLocale(selectedLanguage.text); 
        }
    }, [languageContext.language.id])

    const getUnsubmittedContractDates = (unSubmittedDatesData) => {
        return unSubmittedDatesData.map(
                                        d=> parse(d.revenueDate, "dd/MM/yyyy", new Date())
                                    );
    }

    const getPartiallySubmittedContractDates = (partiallySubmittedDates) => {
        return partiallySubmittedDates.map(
                                            d=> parse(d.revenueDate, "dd/MM/yyyy", new Date())
                                        );
    }
    
    const getSubmittedContractDates = (submittedDatesData) => {
        return submittedDatesData.map(
                                        d=> parse(d.revenueDate, "dd/MM/yyyy", new Date())
                                    );
    }
    
    const unSubmittedDates =props.statusWiseRevenueDates && props.statusWiseRevenueDates.unSubmitted && 
                            props.statusWiseRevenueDates.unSubmitted.length > 0 ? 
                            props.statusWiseRevenueDates.unSubmitted 
                            : [];  

    const partialSubmittedDates = props.statusWiseRevenueDates && props.statusWiseRevenueDates.partial && 
                            props.statusWiseRevenueDates.partial.length > 0 ? 
                            props.statusWiseRevenueDates.partial 
                            : [];   

    const submittedDates =  props.statusWiseRevenueDates && props.statusWiseRevenueDates.submitted && 
    props.statusWiseRevenueDates.submitted.length > 0 ? 
    props.statusWiseRevenueDates.submitted 
    : []; 

    const highlightDatesByStatusData = [{
        "react-datepicker__day--highlighted-submitted" :  getSubmittedContractDates(submittedDates)
        },
        {
        "react-datepicker__day--highlighted-partial" :    getPartiallySubmittedContractDates(partialSubmittedDates)
        },
        {
        "react-datepicker__day--highlighted-unsubmitted" : getUnsubmittedContractDates(unSubmittedDates)
        }];
    
    const getAllStatusData = () => {
        let allContractStatusData = [];

        if (unSubmittedDates && unSubmittedDates.length > 0) {
            unSubmittedDates.map(
                                    d=>allContractStatusData.push(d)
                                );
        }

        if (submittedDates && submittedDates.length > 0) {
            submittedDates.map(
                                d=>allContractStatusData.push(d)
                            );
        }

        if (partialSubmittedDates && partialSubmittedDates.length > 0) {
            partialSubmittedDates.map(
                                        d=>allContractStatusData.push(d)
                                    );
        }

        return allContractStatusData;
    }
    
    useEffect(() => {
        if (props.statusWiseRevenueDates) {
            const allData = getAllStatusData();

            if(allData && allData.length > 0) {
                setHighlightDatesByStatus(highlightDatesByStatusData);
            }
        }
    }, [props.statusWiseRevenueDates]);   

    return (
        <Datepicker className="form-control form-control-sm"
            tabIndex={0}
            onChange={modifiedDate => props.dateChangeHandler(modifiedDate)}
            inline={props.inline}
            strictParsing={true}
            dateFormat="dd/MM/yyyy"
            enableTabLoop={false}
            showPopperArrow={false}
            selected={props.selectedDate}
            onChangeRaw={(e) => setRawDateHandler(e)}
            startDate={props.startDate}
            endDate={props.endDate}
            selectsRange={props.selectsRange}
            showMonthDropdown={props.showMonthDropdown} 
            showYearDropdown={props.showYearDropdown}
            minDate={props.minDate && parse(props.minDate, "dd/MM/yyyy", new Date())} 
            maxDate={props.maxDate && parse(props.maxDate, "dd/MM/yyyy", new Date())} 
            highlightDates={highlightDatesByStatus}
        />
    );
}